import DepsService from 'services/dependencies';

const CONTEXT = 'app';

export const fetchTermsOfUse = async () => {
  const url = DepsService.rest.cms.terms.view.first.url;
  const queryParams = { locale: '*' };
  const urlParams = {};
  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};

export const downloadTermsOfUse = async (contentId) => {
  const url = DepsService.rest.cms.terms.download.url;
  const queryParams = {};
  const urlParams = { contentId };
  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/components/resources/terms-of-use.api.js